<template>
  <div class="pb-2">
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-else>
      <b-card no-body>
        <b-card-header>
          <h4>ข้อมูล</h4>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header>
          <h4>การเงิน/แต้ม</h4>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          <b-tabs v-model="tabIndex">
            <b-tab title="balance เงินบาท" active @click="getBahtBalance()">
              <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="bahtStart" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="bahtEnd" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getBahtBalance()">ค้นหา</b-button>
              </div>

              <b-table
                responsive
                :items="bahtBalanceList"
                :fields="balanceFields"
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(balanceId)="data">
                  <feather-icon
                    :id="`edit-icon-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="editBalance('baht')"
                  />
                  <b-tooltip title="แก้ไข" :target="`edit-icon-${data.value}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(customerId)="data">
                  <feather-icon
                    :id="`delete-icon-${data.item.balanceId}`"
                    icon="Trash2Icon"
                    size="20"
                    class="cursor-pointer text-danger"
                    @click="deleteBalance('baht')"
                  />
                  <b-tooltip title="ลบ" :target="`delete-icon-${data.item.balanceId}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(balanceDate)="data">
                  {{formatDatetime(data.value)}}
                </template>
                <template #cell(description)="data">
                  <span v-if="data.item.income != null">{{data.value}}</span>
                  <span v-else class="pl-1">{{data.value}}</span>
                </template>
                <template #cell(income)="data">
                  <div v-if="data.item.income != null" style="color:green" class="text-right">
                    + {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(expense)="data">
                  <div  v-if="data.item.expense != null" style="color:red" class="text-right">
                    - {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(total)="data">
                  <div class="text-right">
                    {{format_price(data.value)}}
                  </div>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="balance เงินหยวน" @click="getYuanBalance()">
              <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="yuanStart" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="yuanEnd" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getYuanBalance()">ค้นหา</b-button>
              </div>

              <b-table
                responsive
                :items="yuanBalanceList"
                :fields="balanceFields"
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(balanceId)="data">
                  <feather-icon
                    :id="`edit-icon-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="editBalance('yuan')"
                  />
                  <b-tooltip title="แก้ไข" :target="`edit-icon-${data.value}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(customerId)="data">
                  <feather-icon
                    :id="`delete-icon-${data.item.balanceId}`"
                    icon="Trash2Icon"
                    size="20"
                    class="cursor-pointer text-danger"
                    @click="deleteBalance('yuan')"
                  />
                  <b-tooltip title="ลบ" :target="`delete-icon-${data.item.balanceId}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(balanceDate)="data">
                  {{formatDatetime(data.value)}}
                </template>
                <template #cell(description)="data">
                  <span v-if="data.item.income != null">{{data.value}}</span>
                  <span v-else class="pl-1">{{data.value}}</span>
                </template>
                <template #cell(income)="data">
                  <div v-if="data.item.income != null" style="color:green" class="text-right">
                    + {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(expense)="data">
                  <div  v-if="data.item.expense != null" style="color:red" class="text-right">
                    - {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(total)="data">
                  <div class="text-right">
                    {{format_price(data.value)}}
                  </div>
                </template>
              </b-table>
            </b-tab>

            <b-tab title="แต้มสะสม" @click="getPointBalance()">
              <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="pointStart" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="pointEnd" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getPointBalance()">ค้นหา</b-button>
              </div>

              <b-table
                responsive
                :items="pointBalanceList"
                :fields="balanceFields"
                table-class="table-md-responsive text-nowrap"
              >
                <template #cell(balanceId)="data">
                  <feather-icon
                    :id="`edit-icon-${data.value}`"
                    icon="EditIcon"
                    size="20"
                    class="cursor-pointer text-warning"
                    @click="editBalance('point')"
                  />
                  <b-tooltip title="แก้ไข" :target="`edit-icon-${data.value}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(customerId)="data">
                  <feather-icon
                    :id="`delete-icon-${data.item.balanceId}`"
                    icon="Trash2Icon"
                    size="20"
                    class="cursor-pointer text-danger"
                    @click="deleteBalance('point')"
                  />
                  <b-tooltip title="ลบ" :target="`delete-icon-${data.item.balanceId}`" :delay="{show: '1500'}"/>
                </template>
                <template #cell(description)="data">
                  <div v-if="data.item.expense != null" class="pl-1">{{data.value}}</div>
                  <div v-else>{{data.value}}</div>
                </template>
                <template #cell(income)="data">
                  <div v-if="data.item.income != null" class="text-right" style="color:green">
                    + {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(expense)="data">
                  <div v-if="data.item.expense != null" class="text-right" style="color:red">
                    - {{format_price(data.value)}}
                  </div>
                </template>
                <template #cell(total)="data">
                  <div class="text-right">
                    {{format_price(data.value)}}
                  </div>
                </template>
              </b-table>
            </b-tab>
         </b-tabs>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BFormFile, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BFormRadioGroup,
  BFormCheckbox, BFormTextarea, BLink, BCardHeader, BFormRadio, BCardFooter, BModal, VBModal, BForm,
  BImg, BTable, VBToggle, BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
import { format_price, formatDatetime, formatDate_dmy } from '@/views/global_function.js'
export default {
  name: 'Taobao2youCustomerDetail',

  components: {
    BSpinner, BCard, BCardBody, BCardHeader, BFormSelect, BFormInput, BTable, BPagination, BLink, BTooltip,
    BButton,  BTabs, BTab,
    
    vSelect,
    flatPickr,

   },

  data() {
    return {
      customerToken: '',
      tabIndex: 0,

      bahtBalanceList: [],
      yuanBalanceList: [],
      pointBalanceList: [],
      balanceFields: [
        { key: 'balanceId', label: 'แก้ไข', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'customerId', label: 'ลบ', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'balanceDate', label: 'วันที่', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'description', label: 'รายละเอียด'},
        { key: 'income', label: 'เข้า', thClass: 'text-right', tdClass: 'text-right'},
        { key: 'expense', label: 'ออก', thClass:'text-right', tdClass: 'text-right'},
        { key: 'total', label: 'คงเหลือ', thClass: 'text-right', tdClass: 'text-right'},
      ],

      bahtStart: null,
      bahtEnd: null,
      yuanStart: null,
      yuanEnd: null,
      pointStart: null,
      pointEnd: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      //
      loadpage: true
    };
  },

  watch: {
    tabIndex() {
      console.log("tabIndex: ", this.tabIndex);
      
    }
  },
  

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.customerToken = await urlParams.get('id')
    await this.getCustomerDetail()
    await this.getBahtBalance()
    this.loadpage = false
  },

  methods: {
    format_price, formatDatetime, formatDate_dmy,
    async getCustomerDetail() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/get-customer-detail',
        // 'https://localhost:5001/app/Customer/get-customer-detail',
        {
          "id": this.customerToken,
        },
        { headers: header_token }
      )
    },
    async getBahtBalance() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/get-baht-balance-statement',
        // 'https://localhost:5001/app/Customer/get-baht-balance-statement',
        {
          "loginToken": this.customerToken,
          "bathStartDate": this.bahtStart,
          "bathEndDate": this.bahtEnd,
          "isMobile": false
        },
        { headers: header_token }
      )
      this.bahtBalanceList = response.data.customerBalances
      this.bahtStart = response.data.bathStartDate
      this.bahtEnd = response.data.bathEndDate
    },
    async getYuanBalance() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/get-yuan-balance-statement',
        // 'https://localhost:5001/app/Customer/get-yuan-balance-statement',
        {
          "loginToken": this.customerToken,
          "yuanStartDate": this.yuanStart,
          "yuanEndDate": this.yuanEnd,
          "isMobile": false
        },
        { headers: header_token }
      )
      this.yuanBalanceList = response.data.customerYuanBalances
      this.yuanStart = response.data.yuanStartDate
      this.yuanEnd = response.data.yuanEndDate
    },
    async getPointBalance() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/get-point-balance-statement',
        // 'https://localhost:5001/app/Customer/get-point-balance-statement',
        {
          "loginToken": this.customerToken,
          "startDate": this.pointStart,
          "endDate": this.pointEnd,
          "isDescending": true
        },
        { headers: header_token }
      )
      this.pointBalanceList = response.data.balances
      this.pointStart = response.data.startDate
      this.pointEnd = response.data.endDate
    },
    async editBalance(type) {
      if (type == 'baht') {
        console.log('edit baht');
      } else if (type == 'yuan') {
        console.log('edit yuan');
      } else if (type == 'point') {
        console.log('edit point');
      }
    },
    async deleteBalance(type) {
      if (type == 'baht') {
        console.log('del baht');
      } else if (type == 'yuan') {
        console.log('del yuan');
      } else if (type == 'point') {
        console.log('del point');
      }
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>

</style>